import { apiClient } from './api/apiClient';
import { SiteStatus, ChangeSiteStatusRequest, SiteOverview, SiteStatusHistory } from '../types/siteStatus.types';

const BASE_URL = '/sitestatus';

export const siteStatusService = {
  getSiteStatus: async (siteId: number): Promise<SiteStatus> => {
    return await apiClient.get<SiteStatus>(`${BASE_URL}/${siteId}`);
  },

  getAllSitesOverview: async (): Promise<SiteOverview[]> => {
    return await apiClient.get<SiteOverview[]>(`${BASE_URL}/overview`);
  },

  changeSiteStatus: async (siteId: number, data: ChangeSiteStatusRequest): Promise<SiteStatus> => {
    return await apiClient.post<SiteStatus>(`${BASE_URL}/${siteId}/change-status`, data);
  },

  getSiteStatusHistory: async (
    siteId: number,
    from?: string,
    to?: string
  ): Promise<SiteStatusHistory[]> => {
    const params = new URLSearchParams();
    if (from) params.append('from', from);
    if (to) params.append('to', to);

    return await apiClient.get<SiteStatusHistory[]>(`${BASE_URL}/${siteId}/history?${params.toString()}`);
  },
};
